import type { Components } from '@mui/material/styles';

export default function MuiTableBody(): Components['MuiTableBody'] {
  return {};
}
